import { lazy, viewportIntersection } from './lazy-loaders';

const dynamicFn = {
  lazy,
  viewportIntersection,
};

export default dynamicFn;
